if (!customElements.get('mezuzah-handedness')) {
  customElements.define('mezuzah-handedness', class extends HTMLElement {
    connectedCallback() {
      this.armInput = this.querySelector('[data-worn-arm-property]');
      this.handInput = this.querySelector('[data-hand-property]');
      if (!this.armInput || !this.handInput) return;
      this.fields = [
        { input: this.handInput, key: 'hand' },
        { input: this.armInput, key: 'arm' }
      ].map(field => ({ ...field, name: 'properties[' + field.input.dataset.propertyName + ']' }));
      this.choices = new Map(Array.from(this.querySelector('[data-worn-arm-map]').content.querySelectorAll('[data-variant-id]'),
        node => [node.dataset.variantId, { hand: node.dataset.hand, arm: node.dataset.arm }]));
      this.onChange = event => {
        if (event.target.form === this.armInput.form && event.target.name === 'id') this.sync();
      };
      this.onSubmit = event => {
        if (event.target === this.armInput.form) this.sync();
      };
      this.onFormData = event => {
        if (event.target !== this.armInput.form) return;
        const choice = this.sync();
        for (const field of this.fields) {
          if (choice) event.formData.set(field.name, choice[field.key]);
          else event.formData.delete(field.name);
        }
      };
      document.addEventListener('change', this.onChange, true);
      document.addEventListener('submit', this.onSubmit, true);
      document.addEventListener('formdata', this.onFormData, true);
      this.sync();
    }
    sync() {
      const form = this.armInput.form;
      if (!form) return null;
      const choice = this.choices.get(form.querySelector('[name="id"]')?.value);
      for (const field of this.fields) {
        const value = choice?.[field.key] || '';
        if (field.input.value !== value) field.input.value = value;
        if (value && field.input.name !== field.name) field.input.name = field.name;
        else if (!value && field.input.hasAttribute('name')) field.input.removeAttribute('name');
      }
      return choice ?? null;
    }
    disconnectedCallback() {
      document.removeEventListener('change', this.onChange, true);
      document.removeEventListener('submit', this.onSubmit, true);
      document.removeEventListener('formdata', this.onFormData, true);
    }
  });
}
